import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { DebugKey } from '../../model';
import { DebugFacade } from '../facades';

type DebugFeatures = {
  [key in DebugKey]: boolean;
};

@Injectable()
export class DebugService implements DebugFacade {
  private initialValue = Object.keys(DebugKey).reduce(
    (acc, key) => ({
      ...acc,
      [key]: false,
    }),
    {} as DebugFeatures
  );

  private debugFeatures$ = new BehaviorSubject<DebugFeatures>(this.initialValue);

  constructor() {}

  setDebugFeatureValue(key: DebugKey, value: boolean): void {
    if (this.debugFeatures$.value[key] === value) {
      return;
    }

    this.debugFeatures$.next({ ...this.debugFeatures$.value, [key]: value });
  }

  isDebugFeatureEnabled(key: DebugKey): Observable<boolean> {
    return this.debugFeatures$.pipe(map((features) => features[key]));
  }

  enabledFeaturesCount(): Observable<number> {
    return this.debugFeatures$.pipe(map((features) => Object.values(features).filter((value) => value).length));
  }

  resetDebugFeatureValues(): void {
    Object.keys(this.initialValue).forEach((key) => {
      this.setDebugFeatureValue(key as DebugKey, this.initialValue[key]);
    });
  }
}
